/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import * as Yup from 'yup';

import { Countries, CountryCode } from 'shared';

export const validationSchema = Yup.object({
  firstName: Yup.string().required('empty'),
  middleName: Yup.string().nullable(),
  lastName: Yup.string().required('empty'),
  email: Yup.string().required('empty').email('invalid_email'),
  language: Yup.string().required('empty'),

  phoneCountryCode: Yup.mixed().when('phoneNationalNumber', {
    is: v => Boolean(v),
    then: Yup.string().nullable().required('empty'),
    otherwise: Yup.string().nullable(),
  }),
  phoneNationalNumber: Yup.string()
    .nullable()
    .test('only numbers', 'invalid_number_string', function (value) {
      return !value ? true : /^\d+$/.test(value);
    })
    .test('digits length', '', function (value) {
      const { phoneCountryCode } = this.parent;
      if (!phoneCountryCode || !value) return true;

      const { min, max } = Countries[phoneCountryCode as CountryCode].phone;

      if (min === max && value.length !== min) {
        return this.createError({ message: 'exact_digits' });
      }
      if (value.length < min) {
        return this.createError({ message: 'min_digits' });
      }
      if (value.length > max) {
        return this.createError({ message: 'max_digits' });
      }
      return true;
    }),
  address: Yup.object({
    line1: Yup.string().required('empty'),
    line2: Yup.string().nullable(),
    line3: Yup.string().nullable(),
    postalCode: Yup.string().required('empty'),
    city: Yup.string().required('empty'),
    state: Yup.string().nullable(),
    countryCode: Yup.string().required('empty'),
  }),
});
